var render = function () {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "contact-avatar",
      class: ((_obj = {}), (_obj[_vm.size] = true), _obj),
      style: { "--background-color": _vm.getProfileColor() },
    },
    [
      _vm.contact
        ? _c("div", { staticClass: "contact-avatar-image" }, [
            _vm.getContactAvatar() && !_vm.fullname
              ? _c("img", {
                  ref: "image",
                  attrs: { src: _vm.getContactAvatar(), alt: "Contact Avatar" },
                })
              : _c("div", [_vm._v(_vm._s(_vm.getSortedFullname()))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.badge
        ? _c("div", {
            staticClass: "contact-avatar-badge",
            class:
              ((_obj$1 = {}),
              (_obj$1[_vm.badgeType] = !!_vm.badgeType),
              _obj$1),
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }